import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import CoursesCountCell from 'components/reusables/coursesCountCell'
import AssociatedCourses from './associatedCourses'
import { Wrapper } from './styled'

interface IProps {
  data: string[]
  certificateId?: number
}

const Courses = ({ data, certificateId }: IProps) => {
  const translatePrefix = 'administration.certificate.list.create.table'
  const { t } = useTranslation()
  const [isWatching, setIsWatching] = useState(false)

  if (certificateId) {
    return (
      <Wrapper>
        <CoursesCountCell
          certificateId={certificateId}
          count={data.length}
          admin
        />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      {data.length ? (
        <span onClick={() => setIsWatching(true)}>
          {`${data.length} ${
            data.length === 1
              ? t(`${translatePrefix}.headers.associatedCourses`)
              : t(`${translatePrefix}.headers.associatedCoursesPlural`)
          }`}
          <FontAwesomeIcon icon={faEye} />
        </span>
      ) : (
        '--'
      )}
      {isWatching && (
        <AssociatedCourses data={data} close={() => setIsWatching(false)} />
      )}
    </Wrapper>
  )
}

export default Courses
